import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { finalize } from 'rxjs/operators';
import { MapaService } from './../../../../../monitoreo/services/mapa.service';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { ALERTAS } from './../../../../../../_entities/estados';
import { VehiculosService } from './../../../../services/vehiculos.service';
import { AuthService } from './../../../../../auth/auth.service';
import { reportePosiciones } from './../../../../../../_entities/coordenadas/ReportePosiciones';


@Component({
	selector: 'kt-reproduccion',
	templateUrl: './reproduccion.component.html',
	styleUrls: ['./reproduccion.component.scss']
})
export class ReproduccionComponent implements OnInit {
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

	public vehiculoInfo;
	public HWUser;
	public usuario;
	public loadingVisible: boolean = false;
	public reporteQ: any;
	public reportePos: any[] = [];
	public idVehiculo;
	public idCliente;
	public graficar: reportePosiciones[] = [];
	public datosReporte = [];
	public isDisable;
	public showTable;

	public fecha: Date = new Date();
	public horaInicial: Date = new Date();
	public horaFinal: Date = new Date();

	constructor(public datepipe: DatePipe,
		public vehiculosService: VehiculosService,
		public authService: AuthService,
		public mapaService: MapaService,
		public dialogRef: MatDialogRef<ReproduccionComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,) { }

	ngOnInit() {
		this.usuario = this.authService.getUser();
		this.HWUser = this.authService.getHWUser()
		this.vehiculoInfo = this.data;

		this.horaInicial = new Date(this.datepipe.transform(this.fecha, 'yyyy-MM-dd 00:00:00'));
		this.horaFinal = new Date(this.datepipe.transform(this.fecha, 'yyyy-MM-dd 23:59:59'));

		if (JSON.parse(sessionStorage.getItem('historico'))) {
			this.reportePos = JSON.parse(sessionStorage.getItem('historico'))
			this.vehiculoInfo = JSON.parse(sessionStorage.getItem('data'))
			this.idVehiculo = this.vehiculoInfo.id;
			this.idCliente = this.vehiculoInfo.idCliente;
			this.graficar = this.reportePos;
			this.graficar.map(grafica => {
				//grafica.economico = this.vehiculoInfo.descripcion
			})
			this.reportePos.forEach(reporte => {
				this.datosReporte.push({
					'Fecha': reporte.fecha,
					'Placa': reporte.placas,
					'Ignición': reporte.ignicion,
					'Estado': reporte.edo,
					'Velocidad': reporte.velocidad,
					'Latitud': reporte.lat,
					'Longitud': reporte.lng
				});
			});

			if (this.datosReporte.length > 0) {
				this.isDisable = false;
				this.showTable = true;
			}

		} else {
			this.vehiculoInfo = this.data;
			this.graficar.map(grafica => {
				//grafica.economico = this.data.descripcion
			})
			this.idVehiculo = this.data.id;
			this.idCliente = this.vehiculoInfo.idCliente;
		}
	}

	buscarInformacion() {
		const FECHA_INICIO = this.datepipe.transform(this.horaInicial, 'yyyy-MM-dd HH:mm:ss');
		const FECHA_FINAL = this.datepipe.transform(this.horaFinal, 'yyyy-MM-dd HH:mm:ss');

		this.mapaService.historicoFechas = [FECHA_INICIO, FECHA_FINAL];
		this.mapaService.tipoProducto = 'reproduccion';

		this.loadingVisible = true;

		const pageNum = '-1';
		const pageCount = -1
		this.vehiculosService.obtenerAutosCamara( pageNum, pageCount, FECHA_INICIO, FECHA_FINAL, this.data.imeiFk).pipe(
			finalize(
				() => {
					this.loadingVisible = false
					this.cerrarPopup()
				}
			)
		).subscribe(
			(response) => {
				let locations = [];
				if (response.data != null) {
					response.data.forEach((dato, index) => {
						let ignicion = 0;
						let estado = 0
						if (Number(dato.speed) > 5) {
							ignicion = 1;
							estado = 1;
						}

						let formAux = {
							id: index,
							anio: response.vehiculo.anio,
							placas: response.vehiculo.placas,
							economico: response.vehiculo.economico,
							numeroSerie: response.vehiculo.numeroSerie,
							color: response.vehiculo.color,
							descripcion: response.vehiculo.descripcion,
							imagen: response.vehiculo.imagen,
							modelo: response.vehiculo.modelo,
							estatus: response.vehiculo.estatus,
							imeiFk: response.vehiculo.imeiFk,
							lat: Number(dato.latitude),
							lng: Number(dato.longitude),
							estado: estado,
							ignicion: ignicion,
							velocidad: Math.round(dato.speed),
							direccion: response.vehiculo.direccion,
							odometro: response.vehiculo.odometro,
							marca: response.vehiculo.marca,
							fechaHoraUltimaPosicion: response.vehiculo.fechaHoraUltimaPosicion,
							estaEnMovimiento: response.vehiculo.estaEnMovimiento,
							fecha: dato.dtu,
							idPosicion: response.vehiculo.idPosicion,
							idCliente: response.vehiculo.idCliente
						}

						let estado2 = ALERTAS.find(alerta => alerta.id == index.estado);
						let edo = estado2.nombre;
						let ig = "";
						if (formAux.ignicion == 0) {
							ig = "Apagado";
						} else if (formAux.ignicion == 1) {
							ig = "Encendido";
						}

						let vel = `${formAux.velocidad} Km/h`

						//formAux.fecha = this.datepipe.transform(index.fecha, 'dd/MM/yyyy HH:ss a');
						this.reporteQ = { placas: formAux.placas, fecha: formAux.fecha, ignicion: ig, estado: estado2, velocidad: formAux.velocidad, lat: formAux.lat, lng: formAux.lng, edo: edo };
						this.reportePos.push(this.reporteQ)

						sessionStorage.setItem('historico', JSON.stringify(this.reportePos))
						sessionStorage.setItem('data', JSON.stringify(this.vehiculoInfo))

						locations.push(formAux);
					});


					this.mapaService.posicionesReporte = locations;
					/*let datosGenerales: Autos = {
						id: response.vehiculo.id,
						idCliente: response.vehiculo.idCliente,
						anio: response.vehiculo.anio,
						placas: response.vehiculo.placas,
						economico: response.vehiculo.economico,
						numeroSerie: response.vehiculo.numeroSerie,
						color: response.vehiculo.color,
						descripcion: response.vehiculo.descripcion,
						imagen: response.vehiculo.imagen,
						modelo: response.vehiculo.modelo,
						estatus: response.vehiculo.estatus,
						imeiFk: response.vehiculo.imeiFk,
						lat: 0,
						lng: 0,
						estado: response.vehiculo.estado,
						ignicion: response.vehiculo.ignicion,
						velocidad: response.vehiculo.velocidad,
						direccion: response.vehiculo.direccion,
						odometro: response.vehiculo.odometro,
						marca: response.vehiculo.marca,
						fechaHoraUltimaPosicion: response.vehiculo.fechaHoraUltimaPosicion,
						estaEnMovimiento: response.vehiculo.estaEnMovimiento,
						Geocercas: [
							{
								id: 0,
								nombre: ''
							}
						],
					}
					*/
					this.mapaService.datosGenerales = this.vehiculoInfo;
					this.mapaService.pintarMarcadoresHistorico();
					var botonesRecorrido = document.getElementById('botonesRecorrido');
					botonesRecorrido.style.display = 'block';
					this.mapaService.valorLey = true;
					this.mapaService.validarLey();
					this.mapaService.abrirPopupRecorrido();
				}
			}
		);

	}

	public ubicarPuntoHistorico(data) {
		this.mapaService.ubicarPuntoHistorico(data);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
